import { Box, Container, Grid } from "@mui/material";
import SurveyDiary from "../components/surveyDiary/SurveyDiary";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BasicSurveyDiary from "../components/surveyDiary/BasicSurveyDiary";
import NoPermissionPage from "../../components/common/NoPermissionPage";

const ClientAdminSurveryDiary = () => {
  const { userProfile,leadSurveyModulePermission } = useSelector((state: any) => state?.user);
  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
      userProfile?.features?.includes("Basic Survey Diary") || false // Safe fallback
    );

      useEffect(() => {
        setIsBasicDiarySection(userProfile?.features?.includes("Basic Survey Diary") || false); // Sync profile changes
     
      }, [userProfile]);

  return (
    <>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          background: "#f4f4f4",
          paddingTop: "16px",
        
        }}
      >
        <Grid item xs={12} md={12}>
          <Container
            maxWidth="xl"
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
              maxWidth: "100% !important",
            }}
          >
            {userProfile?.roles?.includes("Owner") ||
            userProfile?.roles?.includes("TENANT") ||
            leadSurveyModulePermission?.read ? (
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto", sm: "100vh" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                padding: "4px 12px",
              }}
            >
              {isBasicDiarySection ? 
              <BasicSurveyDiary/> 
              :
              <SurveyDiary />
              }
            </Box>
            ): (
              <>
                <NoPermissionPage />
              </>
            )}
          </Container>
        </Grid>
      </Grid>
    </>
  );
};
export default ClientAdminSurveryDiary;
